import { useMemo } from "react";

import type { UserPageType } from "~/types/user";

export const UserMetadata = ({ user }: { user: UserPageType }) => {
  const totalDecks = useMemo(() => user.decks.length ?? 0, [user]);
  const totalDeckViews = useMemo(
    () => user?.decks.reduce((a, c) => a + c._count.views, 0) ?? 0,
    [user],
  );
  const totalComments = useMemo(
    () =>
      (user._count.comments ?? 0) + (user?.decks.reduce((a, c) => a + c._count.comments, 0) ?? 0),
    [user],
  );
  const totalLikes = useMemo(
    () => (user._count.likes ?? 0) + (user?.decks.reduce((a, c) => a + c._count.likes, 0) ?? 0),
    [user],
  );

  return (
    <div className="mb-2">
      <div>
        <span className="whitespace-nowrap pr-1">{totalDecks} Decks</span>
        <span>{"/"}</span>
        <span className="whitespace-nowrap px-1">{totalDeckViews} Views</span>
        <span>{"/"}</span>
        <span className="whitespace-nowrap px-1">{totalComments} Comments</span>
      </div>

      <div>
        <span className="whitespace-nowrap pr-1">
          <span>{totalLikes}</span>
          <span>&nbsp;Likes</span>
        </span>
        <span>{"/"}</span>
        <span className="whitespace-nowrap px-1">
          <span>{user.followers.length}</span>
          <span>&nbsp;Followers</span>
        </span>
        <span>{"/"}</span>
        <span className="whitespace-nowrap pl-1">
          <span>{user.following.length}</span>
          <span>&nbsp;Following</span>
        </span>
      </div>
    </div>
  );
};
